// extracted by mini-css-extract-plugin
export default {"root":"send-button_root__MZQa5","input":"send-button_input__-5WWP","button":"send-button_button__ASKfE"};